"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportsTableColumns = function (resources) { return [
    {
        dataField: 'serialNumber',
        text: resources.Pack,
        sort: false,
        style: {
            verticalAlign: 'middle'
        },
        headerStyle: {
            width: '30%'
        }
    }, {
        dataField: 'submissionTime',
        text: resources.SubmissionTime,
        sort: false,
        style: {
            verticalAlign: 'middle'
        },
        headerStyle: {
            width: '30%'
        }
    }, {
        dataField: 'action',
        text: resources.Action,
        sort: false,
        style: {
            verticalAlign: 'middle'
        },
        headerStyle: {
            width: '15%'
        }
    }, {
        dataField: 'RAG',
        text: resources.RAG,
        sort: false,
        style: {
            verticalAlign: 'middle'
        },
        headerStyle: {
            textAlign: 'center',
            width: '15%'
        }
    }, {
        dataField: 'UPRC',
        text: resources.UPRC,
        sort: false,
        style: {
            verticalAlign: 'middle'
        },
        headerStyle: {
            textAlign: 'center',
            width: '10%'
        }
    }
]; };
//# sourceMappingURL=ReportsTableColumns.js.map